import { __assign, __rest } from "tslib";
import React from 'react';
import { Button } from '@marvelapp/ui';
export default function EditableTextButton(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Button, __assign({ fontSize: 1, kind: "withShadow", px: 0, py: 0, size: 0 }, props), children));
}
